<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <multi-search :fields="multiFields"></multi-search>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header mt-15 clearfix">
                <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                        <el-button icon="el-icon-plus" type="primary" @click="addResume">新建简历</el-button>
                        <el-dropdown>
                            <el-button type="primary">批量操作<i class="el-icon-caret-bottom el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="recommendResume(multipleSelection)">批量推荐</el-dropdown-item>
                                <el-dropdown-item @click.native="multiChangePosition(idStr)">批量修改职位</el-dropdown-item>
                                <el-dropdown-item @click.native="multiRemarkEdit(idStr)">批量修改备注</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-dropdown>
                            <el-button icon="el-icon-my-daochu" type="info">导出简历<i
                                    class="el-icon-caret-bottom el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="exportFiles(idStr)">导出已选记录(excel)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportFiles(idStr, undefined, undefined, 'type=HTML')">导出已选记录(html)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/resume/exportAllResume.api')">
                                    导出所有查询结果(excel)
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/resume/exportAllResume.api', 'HTML')">
                                    导出所有查询结果(html)
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <export-custom-dialog :valid-call-back="customExportValid" :params-call-back="customExportParams"></export-custom-dialog>
                        <file-upload
                                upload-mode="silence"
                                class="ml-5 mr-5"
                                style="display: inline-block;"
                                :action="`${$axios.defaults.baseURL}/resume/importResume.api`"
                                accept=".rar,.zip"
                                :on-success="uploadSuccess"
                                :fileLimit="0"
                                :showLoading="true">
                            <el-button :plain="true" icon="el-icon-upload2" type="primary">导入简历</el-button>
                            <span slot="tip"></span>
                        </file-upload>
                        <a :href="downloadTemplateUrl">
                            <el-button icon="el-icon-my-daochu" :plain="true" type="text">下载导入模版</el-button>
                        </a>
                    </el-col>
                    <el-col :span="12">
                        <el-row v-if="lists.length" type="flex" justify="end">
                            <el-button icon="el-icon-my-queding color-success" type="success" :plain="true"
                                       @click="changeStatus(idStr,'forceToWrite')"
                                       v-if="hasWritten">进入笔试
                            </el-button>
                            <el-button icon="el-icon-my-queding color-success" type="success" :plain="true"
                                       @click="changeStatus(idStr,'pass')">通过
                            </el-button>
                            <el-button icon="el-icon-my-daiding color-warning" type="warning" :plain="true"
                                       @click="changeStatus(idStr,'undetermined')">待定
                            </el-button>
                            <el-button icon="el-icon-my-guanbi color-danger" type="danger" :plain="true"
                                       @click="changeStatus(idStr,'notPass')">淘汰
                            </el-button>
                            <el-button icon="el-icon-my-lahei color-purple" type="purple" :plain="true"
                                       @click="changeStatus(idStr,'lh')">拉黑
                            </el-button>
                            <el-button icon="el-icon-my-huitui color-info" type="info" :plain="true"
                                       @click="changeStatus(idStr,'back')">回退
                            </el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              border
                              :data="lists"
                              @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="姓名"
                                :show-overflow-tooltip="true"
                                align="center"
                                fixed
                                min-width="80">
                            <template slot-scope="scope">
                                <span class="name-txt" @click="toResumeDetail(scope.row)">
                                    {{ scope.row.resumeForm.name }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.gender"
                                label="性别"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="70">
                            <template slot-scope="scope">{{{1: '男', 2: '女'}[scope.row.resumeForm.gender] || '-'}}</template>
                        </el-table-column>
                        <el-table-column
                                label="岗位"
                                class-name="no-wrap"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                <el-tooltip effect="dark" :content="getPositionTipText(scope.row)" placement="top" v-if="scope.row.oldPositionName || scope.row.newPositionName">
                                    <el-button type="text" icon="el-icon-my-xinxi"></el-button>
                                </el-tooltip>
                                <span :title="scope.row.positionForm.name">{{ scope.row.positionForm.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.positionForm.deptNames }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.mobilePhone"
                                label="手机号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="110">
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.email"
                                label="邮箱"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="110">
                        </el-table-column>
                        <el-table-column
                                label="最高学历"
                                align="center"
                                :show-overflow-tooltip="true"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="最高学历学校"
                                align="center"
                                :show-overflow-tooltip="true"
                                min-width="100">
                            <template slot-scope="scope">
                                <el-tag type="primary" v-if="scope.row.resumeForm.schoolType ==='1'">985</el-tag>
                                <el-tag type="success" v-else-if="scope.row.resumeForm.schoolType ==='2'">211</el-tag>
                                {{ scope.row.resumeForm.resumeMaxEducation.school }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.resumeMaxEducation.major"
                                label="专业"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="140">
                        </el-table-column>
                        <el-table-column
                                label="简历来源"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeForm.resumeSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘来源"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_SOURCE_FROM', scope.row.resumeForm.sourceFrom)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="应聘城市"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="positionForm.sourceFrom"
                                label="投递渠道"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{scope.row.resumeForm && getSelectMapText('WB_ADD_SOURCE',
                                scope.row.resumeForm.addSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="投递人"
                                prop="resumeForm.addName"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                        </el-table-column>
                        <el-table-column
                                label="推荐人"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                <span v-if="scope.row.resumeForm.recommenderUser">{{scope.row.resumeForm.recommenderUser.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘HR"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                            <template slot-scope="scope">
                                <!-- {{ followerText(scope.row.followUpUserInfo) }} -->
                                {{scope.row.positionForm.mark}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                v-if="!isSchool"
                                label="游戏经验"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.gameExperience }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="简历附件"
                                align="center"
                                width="120">
                            <template slot-scope="scope">
                                <attach-view-in-list
                                        :attachList="scope.row.resumeForm.resumeAttachList"></attach-view-in-list>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="投递时间" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope">{{dateFormat(scope.row.commitTime)}}</template>
                        </el-table-column>
                        <el-table-column
                                label="状态"
                                align="center"
                                min-width="130">
                            <template slot-scope="scope">
                                <!-- @mouseleave.native="hidePopover(scope.row)" -->
                                <el-popover v-show="scope.row.evaluator" placement="top"
                                            popper-class="dark-theme popper-line text-center tooltip-status-popover"
                                            :value="scope.row.isPopoverShow"
                                            :popper-options="popper"
                                            @mouseenter.native="beforeShowPopover(scope.row, '/resume/getResumeEvaList.api', 'resumePositionId')"
                                            @mouseleave.native="hidePopover(scope.row)"
                                            trigger="manual">
                                    <div style="width: 550px;max-height:483px;overflow:hidden">
                                        <span v-if="popoverResult.list.length">
                                             <el-row>
                                            <el-col :span="4">评估人</el-col>
                                            <el-col :span="10">内容</el-col>
                                            <el-col :span="3" style="padding-left:10px">状态</el-col>
                                            <el-col :span="7">时间</el-col>
                                        </el-row>
                                        <el-row v-for="(item, index) in popoverResult.list" :key="index">
                                            <el-col :span="4">{{item.evaluationUser.name}}</el-col>
                                            <el-col :span="10" style="display: -webkit-box;-webkit-line-clamp: 6;-webkit-box-orient: vertical;overflow: hidden;">{{item.content || '-'}}</el-col>
                                            <el-col :span="3" style="padding-left:10px">{{getSelectMapText('WB_USER_VIEWPOINT', item.userViewpoint)}}</el-col>
                                            <el-col :span="7" >{{item.evaluateTime || '-'}}</el-col>
                                        </el-row>
                                        </span>
                                        <el-row v-else>暂无数据</el-row>
                                    </div>
                                    <span slot="reference" style="cursor:default" v-loading="scope.row.loading" class="status-loading">
                                        <i class="el-icon-my-xinxi"></i>
                                    </span>
                                </el-popover>
                                <el-tooltip effect="dark" :content="scope.row.operateReason" placement="top-start"
                                            v-if="scope.row.operateReason">
                                    <el-button type="text" icon="el-icon-my-xinxi">
                                        {{getStatusText(scope.row)}}
                                    </el-button>
                                </el-tooltip>
                                <span v-else>{{getStatusText(scope.row)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                class-name="no-wrap"
                                min-width="150">
                            <template slot-scope="scope">
                                <el-dropdown @command="handleCommand" :hide-on-click="false">
                                    <span class="el-dropdown-link">简历评估</span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="`${scope.row.id}/pass`">
                                            <i class="el-icon-my-queding color-success mr-10"></i>通过
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/undetermined`">
                                            <i class="el-icon-my-daiding color-warning mr-10"></i>待定
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/notPass`">
                                            <i class="el-icon-my-guanbi color-danger mr-10"></i>淘汰
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/lh`">
                                            <i class="el-icon-my-lahei color-purple mr-10"></i>拉黑
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/back`">
                                            <i class="el-icon-my-huitui color-info mr-10"></i>回退
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-button type="text" @click="recommendResume(scope.row)">推荐</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="resumeForm.remark" :show-overflow-tooltip="true" label="备注"
                                         align="center"
                                         min-width="120">
                            <template slot-scope="scope">
                                <remark-edit :id="scope.row.resumeForm.id" v-model="scope.row.resumeForm.remark"></remark-edit>
                            </template>
                        </el-table-column>
                        <el-table-column prop="resumeForm.remark" :show-overflow-tooltip="true" label="最近操作人"
                                         align="center"
                                         min-width="130">
                            <template slot-scope="scope">
                                <div style="font-size: 12px;">
                                    <p>{{scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''}}</p>
                                    <p>{{scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)}}</p>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mb-20 mt-10"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        :page-sizes="[20, 50, 100, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
        </div>
        <Add-Resume-Dialog ref="addResumeDialog" @reload="fetchData"></Add-Resume-Dialog>
        <recommend-Resume-Dialog ref="recommendResumeDialog" @reload="fetchData"></recommend-Resume-Dialog>
        <change-position-dialog ref="changePositionDialog" @reload="fetchData"></change-position-dialog>
        <multi-remark-edit-dialog ref="multiRemarkEditDialog" @reload="fetchData"></multi-remark-edit-dialog>
    </div>
</template>

<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import FileUpload from 'components/fileUpload'
    import resumeMixin from './resumeMixin'
    import RemarkEdit from '../operation/remarkEditDialog.vue'
    import MultiRemarkEditDialog from '../operation/multiRemarkEditDialog.vue'
    import AttachViewInList from '../operation/attachViewInList.vue'
    import { dateFormat } from 'modules/tools'
    import manualPopoverMixin from 'mixins/manualPopoverMixin'
    import ChangePositionDialog from 'views/operation/changePositionDialog'
    import MultiSearch from 'views/common/multiSearch'

    export default {
        'extends': QueryListExtend,
        'mixins': [resumeMixin, manualPopoverMixin],
        components: {
            FileUpload, AttachViewInList, ChangePositionDialog, RemarkEdit, MultiRemarkEditDialog, MultiSearch
        },
        data () {
            return {
                popper: {
                    onCreate: () => {
                        console.log('crarrrr')
                    }
                },
                fetchUrl: '/resume/list.api',
                multiFields: [{
                    filter: 'WB_RESUME_STATUS_0',
                    label: '简历状态',
                    mode: 'select',
                    name: 'statusSearch'
                }]
            }
        },
        computed: {
            downloadTemplateUrl () {
                return `${this.$axios.defaults.baseURL}/resume/downloadTemplate.api?token=${this.$store.state.app.token}&property=${this.$store.state.user.property}`
            },
            isSchool () {
                return this.$store.state.user.property === '0'
            },
            hasWritten () {
                const {
                    needIds: { needEntryWritePrject } = {},
                    user: { projectId } = {}
                } = this.$store.state
                return needEntryWritePrject.includes(projectId.toString())
            }
        },
        methods: {
            multiRemarkEdit(ids) {
                if (this.checkDataValid(ids)) {
                    let $target = this.$refs.multiRemarkEditDialog
                    let rids = this.lists
                        .filter(cv => {
                            return ids.indexOf(cv.id) > -1
                        })
                        .map(cv => {
                            return cv.resumeForm.id
                        })
                        .join(',')
                    $target && $target.show(rids)
                }
            },
            pageIndexChange: function (val) {
                this.searchData.pageIndex = val
                console.log()
            },
            dateFormat (date, format = 'yyyy/MM/dd') {
                return dateFormat(date, format)
            },
            addResume () {
                this.$refs.addResumeDialog.show()
            },
            recommendResume (item) {
                if (Array.isArray(item)) {
                    if (this.checkDataValid(item)) {
                        if (item.length > 1) {
                            this.$refs.recommendResumeDialog.show(item, false)
                        } else {
                            this.$refs.recommendResumeDialog.show(item[0])
                        }
                    }
                } else {
                    this.$refs.recommendResumeDialog.show(item)
                }
            },
            uploadSuccess (res, file) {
                this.fetchData()
                const h = this.$createElement
                let nodeContent = res.result.list.map(item => {
                    return h('p', null, item)
                })
                this.$notify({
                    title: '导入结果提示：',
                    message: h('div', null, nodeContent),
                    type: res.result.isAllSuccess ? 'success' : 'error'
                })
            },
            toResumeDetail (row) {
                let path = this.getResumeDetailUrl(row.id, row.status)

                let routeData = this.$router.resolve({ path })
                window.open(routeData.href, '_blank')
            },
            getPositionTipText(row) {
                const { oldPositionName, newPositionName, isJobTransfer } = row

                if (isJobTransfer == 1 && newPositionName) {
                    // 已转岗
                    return `已转岗到${newPositionName}职位`
                } else {
                    // 最新数据
                    return `转岗前：${oldPositionName}职位`
                }
            },
            getStatusText(row) {
                if (row.isJobTransfer == 1) {
                    return '已转岗'
                }

                return this.getSelectMapText('WB_FLOW_STATUS', row.status)
            }
        }
    }
</script>

<style type="text/css" lang="scss">
.el-table__fixed{
    overflow: hidden;
}
.status-loading .el-loading-spinner {
    margin-top: -10px;
    .circular {
        width: 20px;
        height: 20px;
    }
}
.el-table__body-wrapper{
    // overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// resumeList.vue?44ecd6c4